import { Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderProcessingService } from 'src/app/services/portal-supplier/order-processing.service';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';
import { ManufacturerArticleLot, ManufacturerCertificate, ManufacturerRangeSelection } from '../check-order-manufacturer/check-order-manufacturer.models';
import { CheckOrderCertificatesComponent } from '../check-order-manufacturer/check-order-certificates/check-order-certificates.component';
import { OrderHelperService } from 'src/app/services/portal-supplier/order-helper.service';
import { ManufacturerPopoversService } from 'src/app/services/shared/manufacturer-popovers.service';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from 'sweetalert2';
type ManufacturerCheckStep = 1 | 2 | 3 | 4 | 5 | 6;

@Component({
  selector: 'app-history-order-detail',
  standalone: false,
  templateUrl: './history-order-detail.component.html',
  styleUrl: './history-order-detail.component.scss',
})

export class HistoryOrderDetailComponent implements OnInit {
  @ViewChild('ddtFileInput')
  private ddtFileInput?: ElementRef<HTMLInputElement>;

  public productsFromOrder: ProcessingOrders.IProductInOrder[] = [];
  public newBatchToUpload: Partial<ProcessingOrders.IProductBatch> = {
    documents: [],
    batch_year: new Date().getFullYear(),
  };
  public certificates: ManufacturerCertificate[] = [];
  public readonly rangeSelection: ManufacturerRangeSelection | null = null;
  public readonly articleLots: Record<number, ManufacturerArticleLot[]> = {};

  public readonly orderCode: string;
  public activeStep: ManufacturerCheckStep = 5;
  public selectedArticleCode = -1;
  // selectedProduct: ProcessingOrders.IProductInOrder | null = null;
  // selectedBatch: ProcessingOrders.IProductBatch | null = null;
  public processedArticleCodes: number[] = [];
  public orderCompleted = true;
  public openedLotsArticleCode: number | null = null;
  private orderServ = inject(OrderProcessingService);
  public orderToProcess: ProcessingOrders.Certification | null = null;
  public loading = false;
  currentYear = new Date().getFullYear();
  private orderService = inject(OrderHelperService);
  public mServ = inject(ManufacturerPopoversService);
  private readonly router = inject(Router);
  isVisualiza: boolean = false;

  public constructor(
    private readonly route: ActivatedRoute,
    private readonly location: Location,
  ) {
    this.orderCode = this.route.snapshot.paramMap.get('id') ?? '';
  }

  ngOnInit(): void {
    this.getOrderToProcess();
  }

  public get pageTitle(): string {
    if (!this.orderToProcess) {
      return 'Ordine';
    }

    return this.orderToProcess.order_number
      ? `Ordine n°${this.orderToProcess.order_number}`
      : 'Ordine';
  }

  private cdr = inject(ChangeDetectorRef);
  private ngZone = inject(NgZone);
  getOrderToProcess() {
    this.loading = true;

    if (!this.orderCode) {
      this.loading = false;
      return;
    }

    this.orderServ.getCertificationByID(+this.orderCode).subscribe({
      next: (response) => {
        console.log('Order to process response', response);

        this.ngZone.run(() => {
          this.orderToProcess = response;
          this.productsFromOrder = response?.products ?? [];
          this.orderService.ddtDate.next(this.orderToProcess.ddt_date)
          this.loading = false;

          console.log('orderToProcess after assign', this.orderToProcess);
          this.cdr.detectChanges();
        });
      },
      error: (err) => {
        console.error(err);

        this.ngZone.run(() => {
          this.loading = false;
          this.cdr.detectChanges();
        });
      },
    });
  }

  public get selectorLabel(): string {
    if (this.isViewingArticleLots) {
      return 'Scegli articolo';
    }

    switch (this.activeStep) {
      case 1:
        return 'Scegli codice articolo';
      case 2:
        return 'Specifica periodo e range';
      case 3:
        return 'Carica certificati materiali';
      case 6:
      case 4:
        return 'Processa codice articolo';
      case 5:
        return this.orderCompleted
          ? 'Ordine completato!'
          : 'Processa codice articolo';
      default:
        return 'Scegli codice articolo';
    }
  }

  public get selectorValue(): string {
    // if (this.activeStep === 1) {
    //   const orderNumber = this.orderToProcess?.order_number;

    //   return orderNumber ? `Ordine "${orderNumber}"` : 'Ordine';
    // }

    if (this.isViewingArticleLots) {
      return `${this.productToWorkOn?.product_description} - ${this.productToWorkOn?.product_code}` || 'Nessun articolo selezionato';
    }

    return this.productToWorkOn?.product_code
      ? `${this.productToWorkOn?.product_description} - ${this.productToWorkOn?.product_code}`
      : 'Nessun articolo selezionato';
  }

  public get selectorTone(): 'default' | 'success' {
    return this.orderCompleted && !this.isViewingArticleLots
      ? 'success'
      : 'default';
  }

  public get visibleProcessedArticleCodes(): number[] {
    return this.orderCompleted
      ? this.productsFromOrder.map((article) => article.supplier_certificate_product_id)
      : this.processedArticleCodes;
  }

  public get productToWorkOn(): ProcessingOrders.IProductInOrder | null {
    // return this.selectedProduct;
    return this.orderService.selectedProduct.value;
  }

  public get isViewingArticleLots(): boolean {
    return this.activeStep === 5 && this.openedLotsArticleCode !== null;
  }

  public get hasBatch(): boolean {
    return this.activeStep === 5 && this.openedLotsArticleCode !== null;
  }

  public get selectedArticleLots(): ManufacturerArticleLot[] {
    if (!this.openedLotsArticleCode) {
      return [];
    }

    return this.articleLots[this.openedLotsArticleCode] ?? [];
  }

  public get showBackAction(): boolean {
    return (
      this.isViewingArticleLots || !this.orderCompleted || this.activeStep !== 5
    );
  }

  public selectArticle(product: ProcessingOrders.IProductInOrder): void {
    const code = product?.supplier_certificate_product_id ?? -1;
    this.isVisualiza = true;

    console.log('Selected article code', code);
    if (!product || !code) {
      return;
    }
    this.isVisualiza = true;
    this.orderService.selectedProduct.next(product);
    // this.selectedProduct = product;

    if (
      this.activeStep === 5 &&
      this.visibleProcessedArticleCodes.includes(code)
    ) {
      this.openArticleLots(code);
      return;
    }

    this.openedLotsArticleCode = null;
    this.selectedArticleCode = code;
  }


  public batchSelected(product: ProcessingOrders.IProductBatch): void {
    // this.selectedBatch = product;
    this.orderService.selectedBatch.next(product);
    this.orderService.selectedDocuments.next(product?.documents);
    console.log("what is batch ", this.orderService.selectedBatch.value)
  }

  public addLot(code: number): void {
    if (!code) {
      return;
    }

    this.openedLotsArticleCode = null;
    this.selectedArticleCode = code;
    this.newBatchToUpload = {
      documents: [],
      batch_year: new Date().getFullYear(),
    };
    this.activeStep = 2;
  }

  goToList(isGoing: boolean) {
    console.log("isGoing ", isGoing)
    if (isGoing) { this.activeStep = 1; }
    else { this.activeStep = 4; }
  }

  public saveUploadedCertificates(): void {
    if (!this.selectedArticleCode) {
      return;
    }

    this.activeStep = 4;
  }
  get checkFinished() {
    return true;
  }

  public elaborateLot(code: number): void {
    if (!code) {
      return;
    }

    this.openedLotsArticleCode = code;
    this.selectedArticleCode = code;
    this.activeStep = 6;
  }

  public elaborateCustomRange(code: number): void {
    if (!code) {
      return;
    }
    this.openedLotsArticleCode = null;
    this.selectedArticleCode = code;
    this.newBatchToUpload = this.orderService.selectedBatch.value;
    this.orderCompleted = false;
    this.activeStep = 2;
  }

  public prepareAnotherArticle(code: number): void {
    if (!code) {
      return;
    }

    this.openedLotsArticleCode = null;
    this.selectedArticleCode = code;
    this.newBatchToUpload = {
      documents: [],
      batch_year: new Date().getFullYear(),
    };
    this.orderCompleted = false;
    this.activeStep = 2;
  }


  public uploadDdt(): void {
    const fileInput = this.ddtFileInput?.nativeElement;

    if (!fileInput) {
      return;
    }

    fileInput.value = '';
    fileInput.click();
  }


  public back(): void {
    if (this.isVisualiza) {
      this.isVisualiza = false;
      this.openedLotsArticleCode = null;
      return;
    }
    const tab = history.state?.['returnTab'] ?? 'history';
    const base = this.router.url.startsWith('/manufacturer-list') ? 'manufacturer-list' : 'dashboard';
    void this.router.navigate([`/${base}`], { state: { tab } });



  }

  private openArticleLots(code: number): void {
    this.selectedArticleCode = code;
    this.openedLotsArticleCode = code;
  }

}
